// test644
(644 && 0);
